import { useState, useContext, useEffect } from 'react';
import { MyContext } from './MyContext';
import * as moment from 'moment';

const useDowntimeAnalytics = ({ selectedShifts, startDate, endDate, selectedReasonCodes }) => {

    const { downtimeReport, selectedMachines } = useContext(MyContext);
    const [topDowntimeMachine, setTopDowntimeMachine] = useState()

    useEffect(() => {
        if (downtimeReport && selectedMachines && selectedShifts && startDate && endDate && selectedReasonCodes) {
            //console.log("useDowntimeAnalytics downtimeReport: " + downtimeReport.length)
            // console.log("useDowntimeAnalytics selectedMachines: " + selectedMachines.length)
            //console.log("useDowntimeAnalytics selectedShifts: " + selectedShifts.length)
             console.log("useDowntimeAnalytics startDate: " + startDate)
            //console.log("useDowntimeAnalytics endDate: " + endDate)
            //topDowntimeMachine.push({ name: 'hi' })
            downtimeByMachine()
            //setTopDowntimeMachine(result)
            // console.log("result: " + result?.length)

        }
    }, [downtimeReport, selectedMachines, selectedShifts, startDate, endDate, selectedReasonCodes]);

    const downtimeByMachine = () => {
        var dateFormatString = "MM-DD-YYYY"
        var startDateElem = moment(startDate, dateFormatString)
        var endDateElem = moment(endDate, dateFormatString)
        var byMachine = new Map()
        //{}
        downtimeReport.forEach(element => {
            var date = moment(element.date, dateFormatString)
            var shift = element.shift
            //console.log("date: " + date)
            if (date >= startDateElem && date <= endDateElem) {
                if (selectedShifts.includes(shift)) {
                    //loop through each machineName and add them to the byMachine []
                    for (let machineName in element.machinelist) {
                        if (selectedMachines.includes(machineName)) {
                            for (let reasonCodeNum in element.machinelist[machineName]) {
                                //Only include the reasonCodes for the ones the User is viewing
                                //the selectedReasonCodes actually holds the reasonCodes NOT being shown
                                if (!selectedReasonCodes.includes('totals[' + reasonCodeNum + ']')) 
                                {
                                    //we need to differentiate between shift for each reason code
                                    var downtimeCodeShift = reasonCodeNum + "_" + shift
                                    //test for downtimeId
                                    //if (!byMachine[downtimeCodeShift]){
                                    if (!byMachine.has(downtimeCodeShift)) {
                                        //console.log("adding reasonCodeNum: " + reasonCodeNum)
                                        //byMachine[downtimeCodeShift] = new Map()
                                        byMachine.set(downtimeCodeShift, new Map())
                                    }
                                    //test for machineName
                                    //if (!byMachine[downtimeCodeShift][machineName]){
                                    if (!byMachine.get(downtimeCodeShift).has(machineName)) {

                                        //console.log("adding downtimeCodeShift/machineName: " + downtimeCodeShift +"/" + machineName)
                                        //byMachine[downtimeCodeShift][machineName] = 0
                                        byMachine.get(downtimeCodeShift).set(machineName, 0)
                                    }

                                    var currVal = element.machinelist[machineName][reasonCodeNum];
                                    var currTotal = byMachine.get(downtimeCodeShift).get(machineName)
                                    //byMachine[downtimeCodeShift][machineName] += currVal
                                    byMachine.get(downtimeCodeShift).set(machineName, currVal + currTotal)
                                }
                            }

                        }
                    }



                }
            }
            setTopDowntimeMachine(byMachine)
        });


    }
    // useEffect(() => {
    //     console.log("useDowntimeAnalytics useEffect selectedMachines: " + selectedMachines)
    // }, [selectedMachines]);

    return {
        topDowntimeMachine
    };

}
export default useDowntimeAnalytics;